import { createContext } from "react";

export const apiContext = createContext();
